/**
 * composables/display.js
 *
 * Single source of truth for the phone gate used by the responsive work
 * (see docs/responsive-mobile-proposal.md). The gate is Vuetify's `xs`
 * breakpoint (<600px): desktop and tablets (>=600px) must never change
 * behavior based on it.
 */
import { useDisplay } from 'vuetify'

export function useIsPhone () {
  const { xs, width } = useDisplay()
  return {
    isPhone: xs, // reactive ref: true only below 600px
    displayWidth: width, // reactive ref: current viewport width in px
  }
}
